<template>
	<v-dialog v-model="isVisibleConfirm" persistent max-width="400">
		<card class="tw-p-6">
			<v-card-title class="confirm-title">{{ title }}</v-card-title>
			<v-card-text class="confirm-message" v-if="message">{{ message }}</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary" class="custom-button black" style="margin-right: 10px !important;" @click="onCancel">{{ cancelText }}</v-btn>
				<v-btn color="primary" class="custom-button" @click="onConfirm">{{ okText }}</v-btn>
			</v-card-actions>
		</card>
	</v-dialog>
</template>

<script>
import Card from '@/modules/shared/components/ui/Card/Card';

export default {
	name: 'ConfirmDialog',
	components: { Card },
	data() {
		return {
			isVisibleConfirm: false,
			onOkClick: () => {},
			title: '',
			message: '',
			cancelText: '',
			okText: '',
		};
	},
	methods: {
		showConfirm({ onOk, title, message, cancelText = 'No', okText = 'Sí' }) {
			this.isVisibleConfirm = true;
			this.onOkClick = onOk;
			this.title = title;
			this.message = message;
			this.cancelText = cancelText;
			this.okText = okText;
		},
		onConfirm() {
			this.isVisibleConfirm = false;
			this.onOkClick();
		},
		onCancel() {
			this.isVisibleConfirm = false;
		},
	},
};
</script>

<style lang='scss' scoped>
.confirm-title {
	font-size: 20px;
	line-height: 24px;
}
.confirm-title, .confirm-message {
	color: var(--app-color-info);
}
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/ui/ConfirmDialog.vue